import React from "react";

const LightMode = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 512 512"
      version="1.1"
      viewBox="0 0 512 512"
      width="1em"
      height="1em"
    >
      <path
        fill="#FF5E6B"
        d="M483.564 292.043L512 256 483.564 219.957 499.471 176.891 461.288 151.401 463.109 105.527 418.917 93.083 406.473 48.891 360.599 50.712 335.109 12.529 292.043 28.437 256 0 219.957 28.437 176.891 12.529 151.401 50.712 105.527 48.891 93.083 93.083 48.891 105.527 50.712 151.401 12.529 176.891 28.436 219.957 0 256 28.436 292.043 12.529 335.109 50.712 360.599 48.891 406.473 93.083 418.917 105.527 463.109 151.401 461.288 176.891 499.47 219.957 483.564 256 512 292.043 483.564 335.109 499.47 360.599 461.288 406.473 463.109 418.917 418.917 463.109 406.473 461.288 360.599 499.471 335.109z"
      ></path>
      <circle cx="256" cy="256" r="205.233" fill="#FFCE1C"></circle>
      <g fill="#3B484A">
        <path d="M159.893 267.781a7.726 7.726 0 01-7.726-7.726v-17.394a7.726 7.726 0 1115.452 0v17.394a7.725 7.725 0 01-7.726 7.726zM352.107 267.781a7.726 7.726 0 01-7.726-7.726v-17.394a7.726 7.726 0 1115.452 0v17.394a7.726 7.726 0 01-7.726 7.726zM256 277.065c-11.474 0-22.241-4.788-29.537-13.136a7.726 7.726 0 1111.634-10.17c4.362 4.991 10.888 7.853 17.902 7.853 7.016 0 13.542-2.863 17.904-7.853a7.725 7.725 0 0110.902-.732 7.725 7.725 0 01.732 10.902c-7.296 8.349-18.063 13.136-29.537 13.136z"></path>
      </g>
    </svg>
  );
}

export default LightMode;